module.exports = __webpack_public_path__ + "img/kommune-1432.cf6a16cc.svg";